module.exports = __webpack_public_path__ + "static/media/COS_3M.581c2b09.png";